import JSZip from 'jszip';
import SHA256 from 'crypto-js/sha256';
import FileSaver from "file-saver";
import {nanoid} from 'nanoid';
import apiService from '../../services/api.service';
import firebaseService from '../../services/firebase.service';

// action types
export const SIGNPROOF_DOWNLOAD_PDF = 'signproofDownloadPdf';
export const SIGNPROOF_SIGNSTAMP_PDF = 'signproofSignstampPdf';
export const SIGNPROOF_DELETE_REPORT = 'deleteSignproofReport';
export const SIGNPROOF_INVITE_SIGNATORY = 'signproofInviteSignatory';
export const SIGNPROOF_SAVE_INVITATION_DATA = 'signproofSaveInvitationData';
export const SIGNPROOF_FETCH_INVITATION_DATA = 'signproofFetchInvitationData';
export const SIGNPROOF_DELETE_OLD_PDF_DOCUMENT = 'signproofDeleteOldPdfDocument';
export const SIGNPROOF_SIGN_INVITATION_DOCUMENT = 'signproofSignInvitationDocument';
export const SIGNPROOF_UPDATE_SIGNED_PDF_DOCUMENT = 'signproofUpdateSignedPdfDocument';
export const SIGNPROOF_IS_ALL_SIGNATURES_FULLY_DONE = 'signproofIsAllSignaturesFullyDone';


// mutation types
const SET_REPORTS = 'setReports';
const SET_REPORT_FIELDS = 'saveReportFields';
const SET_FETCHED_INVITATION_DATA = 'setInvitationData';
const SET_FETCHED_REPORT_DATA = 'setFetchedInvaitationReport';


const state = {
   fetchedInvitationData: {}
};

const getters = {
   fetchedInvitationData: (state) => {
      return state.fetchedInvitationData;
   },
};

const mutations = {
   [SET_REPORTS](state, reports) {
      state.reports = reports;
   },
   [SET_FETCHED_INVITATION_DATA](state, data) {
      state.fetchedInvitationData = data;
   },
   [SET_FETCHED_REPORT_DATA](state, data) {
      state.fetchedReportData = data;
   }
};

const actions = {
   [SIGNPROOF_SIGNSTAMP_PDF](context) {
      return new Promise((resolve, reject) => {
         let formdata = new FormData;
         formdata.append('pdf_url', context.getters.reportFields.source);
         formdata.append('sign_name', context.getters.reportFields.sign_name);
         formdata.append('sign_font', context.getters.reportFields.sign_font);
         formdata.append('sign_sign', context.getters.reportFields.sign_sign);
         apiService.setPdfApiAsBaseUrl();
         apiService.post('/pdf/signstamp', formdata).then((res) => {
            context.getters.reportFields.uid = context.getters.user.uid;
            context.getters.reportFields.user = context.getters.user.name;
            context.getters.reportFields.email = context.getters.user.email;
            context.getters.reportFields.captured_file = res.data.url;
            context.getters.reportFields.captured_file_id = res.data.id;
            context.getters.reportFields.captured_file_hash = SHA256(`${res.data.url}_${nanoid()}`).toString().substr(0, 25);
            resolve(res.data);
         }).catch((err) => {
            reject(`[signproofSignstampPdf] => ${err}`)
         });
      });
   },
   [SIGNPROOF_DOWNLOAD_PDF](context, id) {
      return new Promise((resolve, reject) => {
         let files = [
            {name: 'signproof.pdf', url: `/signproof/${id}`},
            {name: 'certtificate.pdf', url: `/certificate/${id}`}
         ];

         let zip = new JSZip();
         const promises = [];
         files.forEach((item) => {
            const promise = apiService.setPdfDownloadAsBaseUrlNew(item.url).then((arraybuffer) => {
               zip.file(item.name, arraybuffer);
            }).catch((err) => {
               reject(`[signproofDownloadPdfFromServer] => ${err}`)
            });
            promises.push(promise);
         });

         Promise.all(promises).then(() => {
            zip.generateAsync({type: "blob"}).then(content => {
               FileSaver.saveAs(content, "file.zip");
               resolve(true);
            });
         });
      });
   },
   [SIGNPROOF_INVITE_SIGNATORY](context, emails) {
      return new Promise((resolve, reject) => {
         let formdata = new FormData;
         formdata.append('user', context.getters.user.name);
         formdata.append('emails', emails);
         apiService.setPdfApiAsBaseUrl();
         apiService.post('/mail/invite/signatory', formdata).then((res) => {
            context.commit(SET_FETCHED_INVITATION_DATA, res.data);
            resolve(true);
         }).catch((err) => {
            reject(`[signproofInviteSignatory] => ${err}`)
         });
      });
   },
   [SIGNPROOF_SAVE_INVITATION_DATA](context) {
      return new Promise((resolve, reject) => {
         const data = context.getters.fetchedInvitationData;
         const report_id = context.getters.reportFields.id;
         data.forEach((invitation, index) => {
            if(invitation.mail_delivered) {
               firebaseService.saveInvitation(invitation, index, report_id).then(() => {
                  resolve(true);
               }).catch((err) => {
                  reject(`[signproofSaveInvitationData] => ${err}`)
               })
            }
         });
      });
   },
   [SIGNPROOF_FETCH_INVITATION_DATA](context, invitation_id) {
      return new Promise((resolve, reject) => {
         firebaseService.fetchInvitation(invitation_id).then((invitation) => {
            if(invitation) {
               context.commit(SET_FETCHED_INVITATION_DATA, invitation);
               firebaseService.fetchInvitationReport(invitation.report_id).then((report) => {
                  context.commit(SET_FETCHED_REPORT_DATA, report);
                  resolve(true);
               }).catch((err) => {
                  context.commit(SET_FETCHED_REPORT_DATA, null);
                  reject(`[signproofFetchInvitationData - 1] => ${err}`);
               });
            } else {
               context.commit(SET_FETCHED_REPORT_DATA, null);
               context.commit(SET_FETCHED_INVITATION_DATA, null);
            }
         }).catch((err) => {
            context.commit(SET_FETCHED_REPORT_DATA, null);
            reject(`[signproofFetchInvitationData - 0] => ${err}`);
         });
      });
   },
   [SIGNPROOF_SIGN_INVITATION_DOCUMENT](context) {
      return new Promise((resolve, reject) => {
         let formdata = new FormData;
         formdata.append('pdf_url', context.getters.fetchedReportData.captured_file);
         formdata.append('position', context.getters.fetchedInvitationData.index);
         formdata.append('sign_name', context.getters.reportFields.sign_name);
         formdata.append('sign_font', context.getters.reportFields.sign_font);
         formdata.append('sign_sign', context.getters.reportFields.sign_sign);
         apiService.setPdfApiAsBaseUrl();
         apiService.post('/pdf/signstamp/invitation', formdata).then((res) => {
            console.log(res.data);
            context.commit(SET_REPORT_FIELDS, res.data);
            resolve(res.data);
         }).catch((err) => {
            reject(`[signproofSignInvitationDocument] => ${err}`)
         });
      });
   },
   [SIGNPROOF_UPDATE_SIGNED_PDF_DOCUMENT](context) {
      return new Promise((resolve, reject) => {
         const report_id = context.getters.fetchedReportData.id;
         const source_id = context.getters.reportFields.id;
         const source_url = context.getters.reportFields.url;
         const invitation_id = context.getters.fetchedInvitationData.id;
         firebaseService.updateReport(report_id, source_id, source_url).then(() => {
            firebaseService.updateInvitation(invitation_id).then(() => {
               resolve(true);
            }).catch(() => {
               resolve(false);
            });
         }).catch((err) => {
            reject(`[signproofUpdateSignedPdfDocument] => ${err}`)
         });
      });
   },
   [SIGNPROOF_IS_ALL_SIGNATURES_FULLY_DONE](context) {
      return new Promise((resolve, reject) => {
         let status = [];
         const report_id = context.getters.fetchedReportData.id;
         firebaseService.fetchAllInvitation(report_id).then(async (invitations) => {
            invitations.forEach((invitation) => {
               if (invitation.status === 'done') {
                  status.push(invitation.status);
               }
            });
            if (status.length >= invitations.length) {
               console.log('done with signatures');
               await firebaseService.updateReportAllSignaturesAsComplete(report_id)
            }
            resolve(true);
         }).catch((err) => {
            context.commit(SET_FETCHED_REPORT_DATA, null);
            reject(`[signproofIsAllSignaturesFullyDone] => ${err}`);
         });
      });
   },
   [SIGNPROOF_DELETE_OLD_PDF_DOCUMENT](context) {
      return new Promise((resolve, reject) => {
         let formdata = new FormData;
         const file_id = context.getters.fetchedReportData.captured_file_id;
         console.log(file_id);
         formdata.append('pub_id', file_id);
         apiService.setPdfApiAsBaseUrl();
         apiService.post('/pdf/delete', formdata).then(() => {
            resolve(true);
         }).catch((err) => {
            reject(`[signproofDeleteOldPdfDocument] => ${err}`)
         });
      });
   },
   [SIGNPROOF_DELETE_REPORT](context, {id, source_id, captured_file_id}) {
      return new Promise((resolve, reject) => {
         firebaseService.deleteReport(id).then(() => {
            let files = [
               {id: source_id},
               {id: captured_file_id}
            ];

            const promises = [];
            files.forEach((item) => {
               apiService.setPdfApiAsBaseUrl();
               const promise = apiService.post('/pdf/delete', {"pub_id": item.id}).then(() => {
                  promises.push(promise);
               }).catch((err) => {
                  reject(`[deleteSignproof] => ${err}`)
               });
            });

            Promise.all(promises).then(() => {
               const reports = context.getters.reports;
               context.commit(SET_REPORTS, reports.filter((el) => el.id !== id));
               resolve(true);
            });
         }).catch((err) => {
            reject(`[deleteReport] => ${err}`)
         });
      });
   },
};

export default {
   state,
   getters,
   actions,
   mutations,
}

